export default function serviceIsOwner(serviceSlug) {
  const ownerSlugs = ["powur_enterprise", "powur_enterprise_pro"];

  return ownerSlugs.includes(serviceSlug);
}
